import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schedule-entries--form-modal"
export default class extends Controller {
  static targets = ["radioTimeSlice", "selectVacationPattern", "selectSecondaryVacationPattern", "workTypeSelect", "toolSelect", "projectPartSelect"];

  connect() {
    if (this.hasProjectPartSelectTarget && this.projectPartSelectTarget.value) {
      this.fetchAndApplyProjectPartData(this.projectPartSelectTarget.value, false);
    }
  }

  toggleVacationPattern(event) {
    const checked   = !!event ? event.currentTarget : this.radioTimeSliceTargets.find(radio => radio.checked);
    const name      = checked.dataset.name;
    const isFullDay = name === "day";

    if (isFullDay) {
      this.selectSecondaryVacationPatternTarget.value = null;
    } else {
      const option = Array.from(this.selectVacationPatternTarget.options).find(
        opt => opt.text === "出勤"
      );

      this.selectVacationPatternTarget.value = option ? option.value : null;
    }

    this.selectVacationPatternTarget.disabled = !isFullDay;
    this.selectSecondaryVacationPatternTarget.disabled = isFullDay;
  }

  async handleProjectPartChange(event) {
    await this.fetchAndApplyProjectPartData(event.target.value, true);
  }

  async fetchAndApplyProjectPartData(selectedId, overwrite) {
    if (!selectedId) {
      this.resetSelect(this.workTypeSelectTarget);
      this.resetSelect(this.toolSelectTarget);
      return;
    }

    try {
      const response = await fetch(`/project_parts/${selectedId}.json`);
      if (!response.ok) throw new Error("Network response was not ok");
      
      const data = await response.json();
      
      if (data.on_site) {
        this.enableSelect(this.workTypeSelectTarget, data.project?.default_work_type_id, overwrite);
        this.enableSelect(this.toolSelectTarget, data.project?.default_tool_id, overwrite);
      } else {
        this.resetSelect(this.workTypeSelectTarget);
        this.resetSelect(this.toolSelectTarget);
      }
    } catch (error) {
      console.error("Failed to fetch project part data:", error);
    }
  }

  resetSelect(selectTarget) {
    if (selectTarget) {
      selectTarget.disabled = true;
      selectTarget.value = "";
    }
  }

  enableSelect(selectTarget, defaultValue, overwrite = true) {
    if (selectTarget) {
      selectTarget.disabled = false;
      if (defaultValue && (overwrite || !selectTarget.value)) {
        selectTarget.value = defaultValue;
      }
    }
  }
}
